module.exports = __webpack_public_path__ + "static/media/offres_auto_4.a4b5f9b2.png";